import { Money, TransactionType } from 'types';
import { toDisplayDateFormat } from 'lib/utils/date';
import LineItem from 'components/LineItem';

export interface QantasPointsLineItemProps {
  type: TransactionType;
  createdAt: string | Date;
  qffNumber: string;
  total: Money;
}

const QantasPointsLineItem = ({ type, createdAt, qffNumber, total }: QantasPointsLineItemProps) => (
  <LineItem title="Qantas Points" totals={[total]}>
    {type === 'REFUND'
      ? `Refunded on ${toDisplayDateFormat(createdAt)} to QFF account ${qffNumber}`
      : `Redeemed on ${toDisplayDateFormat(createdAt)} from QFF account ${qffNumber}`}
  </LineItem>
);

export default QantasPointsLineItem;
